import React from "react";
import Header from "../../components/HorizontalLayout/Header";
import Footer from "../../components/HorizontalLayout/Footer";
import Sidebar from "../../components/HorizontalLayout/Sidebar";

const Authmiddleware = (props) => {

  // if (!localStorage.getItem("authUser")) {
  //   return (
  //     <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
  //   );
  // }

  return (
    <React.Fragment>
      <Sidebar />
      <div className="flex flex-col dark:bg-darkColor dark:border-darkColor dark:text-darkColor bg-lightColor border-lightColor text-lightColor  transition duration-300 ease-in-out  min-h-screen font-inter">
        <Header />
        <div className="grow">
          <div className="flex flex-row">
            <div className="lg:container lg:mx-auto xl:max-w-screen-xl w-full flex flex-row gap-3 justify-between items-center py-2 pb-5  ">
              {props.children}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </React.Fragment>);
};

export default Authmiddleware;
